var SIDEBAR_MIN_WIDTH = 240;
var TOP_HEADER_HEIGHT = 64;

export { SIDEBAR_MIN_WIDTH, TOP_HEADER_HEIGHT };
